import { LinkProps } from "next/link"
import React from "react"
import { GridColumnProps } from "styled-system"
import { ArrowRight } from "../../Icons"
import * as S from "./elements"
import IntlLink from "@components/Intl/IntlLink"

interface Props extends LinkProps, GridColumnProps {
  image: string
  ratio?: string[]
}

const LooksCard: React.FC<Props> = ({ href, as, image, ratio, gridColumn }) => {
  return (
    <IntlLink href={href} as={as}>
      <S.Anchor
        title="View look"
        ratio={ratio}
        gridColumn={gridColumn}
        href={typeof as === "string" ? as : undefined}
      >
        <S.Background
          loading="lazy"
          src={image}
          alt="look-preview"
        ></S.Background>
        <S.Content>
          View
          <ArrowRight />
        </S.Content>
      </S.Anchor>
    </IntlLink>
  )
}

export default LooksCard
